module.exports = {
	"taxes": {
		"attributes": {
			"id": "ID",
			"name": "Nome",
			"scope": "Escopo",
			"value": "Valor",
			"status": "Status",
			"active": "Ativo",
			"inactive": "Inativo",
			"statuses": {
				"true": "Ativo",
				"false": "Inativo"
			}
		},
		"main": {
			"title": "Impostos",
			"list_taxes": "Listagem de impostos",
			"placeholder": {
				"id": "Ex: 123",
				"name": "Ex: COFINS",
				"init_value": "Ex: 5,85",
				"final_value": "Ex: 30,99"
			}
		},
		"show": {
			"view_tax": "Visualizar imposto cadastrado",
			"details": "Detalhes do imposto",
			"since": "Desde %{date}",
			"tax_status": "Status do imposto",
			"tax_name": "Nome do imposto",
			"tax_value": "Valor do imposto",
			"tax_scope": "Escopo do imposto",
			"active_in_contract": "Assinaturas que utilizam o imposto"
		},
		"new": {
			"new_tax": "Novo imposto",
			"value": "Valor do imposto",
			"value_information": "O valor informado no imposto será interpretado como porcentagem.",
			"name_and_scope": "Nome e escopo",
			"name_and_scope_information": "Insira o nome do imposto, por exemplo: 'PIS, COFINS'. O escopo refere-se ao motivo/critério para aplicação do imposto.",
			"placeholder": {
				"name": "Ex: COFINS",
				"scope": "Ex: São Paulo"
			},
			"popover": {
				"value": "Valor do imposto em porcentagem"
			}
		},
		"edit": {
			"title": "Edição de impostos"
		},
		"modal": {
			"activate_tax": "Ativar imposto",
			"inactive_tax": "Inativar imposto",
			"activate_tax_message": "Ao ativar este imposto ele voltará a ser cobrado em todas as assinaturas que o utilizam.",
			"inactive_tax_message": "Ao inativar este imposto ele deixará de ser cobrado em todas as assinaturas que o utilizam.",
			"activate_message": "<p>Deseja realmente reativar o imposto <strong>{tax}</strong>?</p>",
			"inactive_message": "<p>Deseja realmente inativar o imposto <strong>%{tax}</strong>?</p>"
		},
		"buttons": {
			"new_tax": "Incluir imposto",
			"edit_tax": "Editar imposto"
		},
		"messages": {
			"tax_created": "Novo imposto incluido com sucesso!",
			"inactive_tax": "Imposto %{tax} inativado com sucesso!",
			"activate_tax": "Imposto %{tax} ativado com sucesso!",
			"tax_changed": "Imposto %{tax} alterado com sucesso!"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/taxes/pt-BR.yml
// module id = 595
// module chunks = 1